import Vue from 'vue';
import Router from 'vue-router';
import ResizeObserver from 'resize-observer-polyfill';

// Views
import Browser from '@/views/Browser.vue';
// import Country from "@/views/Country.vue";
// import CountryPart from "@/views/CountryPart.vue";
import Investment from '@/views/Investment.vue';
import List from '@/views/List.vue';
import Favourites from '@/views/Favourites.vue';
import Floor from '@/views/Floor.vue';
import Flat from '@/views/Flat.vue';
import Building from '@/views/Building.vue';
import Cards from '@/views/Cards.vue';
// import Login from "@/views/Login.vue";
import noPath from '@/views/404.vue';

// Init
Vue.use(Router);

// Variables
var previousOffset = {};
var pop = false;
var routes = [
  // {
  //   path: "/login",
  //   name: "login",
  //   component: Login,
  // },
  {
    path: '/404',
    name: '404',
    component: noPath,
  },
  {
    path: '/',
    alias: '/',
    component: Browser,
    name: 'browser',
    children: [
      // { path: "", name: "country", component: Country },

      { path: '/', redirect: '/baltic-wave/building/A' },
      { path: '/en/', redirect: '/baltic-wave/building/A' },
      { path: '/de/', redirect: '/baltic-wave/building/A' },
      // {
      //   path: "country/:part",
      //   alias: "/kraj/:part",
      //   name: "country-part",
      //   component: CountryPart,
      //   props: true,
      // },
      {
        path: 'favourites',
        name: 'favourites',
        component: Favourites,
      },
      {
        path: ':investment',
        name: 'investment',
        component: Investment,
        props: true,
      },
      {
        path: ':investment/building/:building',
        alias: ':investment/budynek/:building',
        name: 'building',
        component: Building,
        props: true,
      },
      {
        path: ':investment/building/:building/floor/:floor',
        alias: ':investment/budynek/:building/pietro/:floor',
        name: 'floor',
        component: Floor,
        props: true,
      },
      {
        path: ':investment/flat/:flat',
        alias: ':investment/mieszkanie/:flat',
        name: 'flat',
        component: Flat,
        props: true,
      },
      {
        path: ':investment/cards',
        alias: ':investment/karty',
        name: 'cards',
        component: Cards,
      },
      {
        path: ':investment/list',
        alias: ':investment/lista',
        name: 'list',
        component: List,
      },
    ],
  },
  {
    path: '/*',
    name: '404',
    component: noPath,
  },
];

const scrollBehavior = function(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active--exact',
  linkActiveClass: 'active',
  routes,
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  let scrollWrapper = document.querySelector('.main');
  if (scrollWrapper) {
    previousOffset[from.path] = scrollWrapper.scrollTop;
  }

  if (to.name && from.name) {
    next(to.fullPath != from.fullPath);
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  let scrollWrapper = document.querySelector('.main');
  if (scrollWrapper) {
    if (pop) {
      setTimeout(() => {
        scrollWrapper.scrollTop = previousOffset[to.path];
      }, 250);
      pop = false;
    } else if (to.path != from.path || to.name == 'list') {
      setTimeout(() => {
        scrollWrapper.scrollTop = 0;
      }, 250);
    }
  }
});

window.addEventListener('popstate', () => {
  pop = true;
});

let windowHeight = window.innerHeight;

const resizeObserver = new ResizeObserver(entries => {
  if (windowHeight !== entries[0].target.clientHeight) {
    windowHeight = entries[0].target.clientHeight;
    window.top.postMessage(
      `CONTENT_HEIGHT/${entries[0].target.clientHeight}`,
      '*'
    );
  }
});

resizeObserver.observe(document.body);

window.addEventListener('message', e => {
  if (e.data && typeof e.data == 'string') {
    if (e.data.includes('FLAT')) {
      const flat = e.data.split('/')[1];
      router.push(`/baltic-wave/flat/${flat}`);
    } else if (e.data.includes('CHANGE_ROUTE')) {
      const route = e.data.split('|')[1];
      router.push(route);
    }
  }
});

export default router;
